import React, { Component } from 'react'

import { Link } from "react-router"
import { Row } from "elemental"
import shop from "../../shop/shop"


class ProductSearchBasic extends Component {

  state = {
    products: []
  }

  componentWillReceiveProps( props ) {
    if ( props !== this.props ) {
      console.log( "LOADING", props )
      this.load( props )
    }
  }

  componentDidMount() {
    this.load( this.props )
  }

  load( { cats = [], query } ) {
    window.setTimeout( () => {
        console.log( `loading`, cats )
        if ( cats.length > 0 ) this.loadFromCategories( cats, query )
        if ( cats.length === 0 ) this.loadSearch( query )
      },
      320 * 2
    )
  }

  loadSearch( query ) {
    this.lastQuery = { query }
    console.info( "load search SUPER", query )
    shop.products.query( query ).then( this.handleProducts )
  }

  loadFromCategories( cats, query ) {
    this.lastQuery = { cats, query }
    shop.products.fromCategory( cats, {
      count: 5, page: 1, query
    } )
      .then( this.handleProducts )
  }

  handleProducts = ( response ) => {
    console.log( "SEARCH", { response } )
    let { products } = response
    this.setState( { products } )
    if ( this.props.onload ) {
      this.props.onload( response )
    }
  }

  render() {
    let Child = this.props.repeat
    let { title, to } = this.props
    let products = this.state.products.map( product => <Child key={product.map_id}
                                                              product={product}/> )

    if ( products.length === 0 ) {
      return null
    }

    return (
      <div key={this.props.key}>
        {(title) ? <div className="row-title">
          {to && <Link to={to}><h2>{title}</h2></Link>}
          {!to && <h2>{title}</h2>}
        </div> : null}

        <Row>
          {products}
        </Row>
      </div>
    )
  }
}


export default ProductSearchBasic



// WEBPACK FOOTER //
// ./src/components/Product/ProductSearchBasic.js